import React, { FC } from 'react';
import {
  FormControl,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
} from '@mui/material';
import { ContentCopy } from '@mui/icons-material';
import MfButton from '../UI/Button/MfButton';
import { Session } from '../../structures/response/Session';
import { formatUnixDateTime } from '../../helpers/formatHelper';
import useAccount from '../../hooks/useAccount';
import useClosableSnackbar from '../../hooks/useClosableSnackbar';
import styles from './SessionItem.module.scss';

interface Props {
  data: Session;
  onClose: (id: number, isCurrent: boolean) => Promise<void>;
}

const SessionItem: FC<Props> = ({
  data: { client, device, ip, location, platform, lastUsingAt, id, isCurrent },
  onClose,
}: Props) => {
  const lastSeen = formatUnixDateTime(lastUsingAt);
  const { accountResponse } = useAccount();
  const { showSnackbar } = useClosableSnackbar();

  return (
    <div>
      <Grid container spacing={2}>
        <Grid item flexGrow={1}>
          <div>
            {client} {device}
          </div>
          <div>
            <div>
              {ip} {location}
            </div>
            <div>OS {platform}</div>
            <div>Последняя активность {lastSeen}</div>
          </div>
          {isCurrent && (
            <div>
              <div className={styles.captionThisDevice}>Это устройство</div>
              <FormControl
                fullWidth
                size="small"
                sx={{ my: 1 }}
                variant="outlined"
              >
                <InputLabel shrink>Access Token</InputLabel>
                <OutlinedInput
                  readOnly
                  type="text"
                  value={accountResponse?.accessToken}
                  endAdornment={
                    <InputAdornment position="start">
                      <IconButton
                        onClick={() => {
                          navigator.clipboard
                            .writeText(accountResponse?.accessToken || '')
                            .then(
                              () => {
                                showSnackbar('Access Token успешно скопирован');
                              },
                              () => {
                                console.log('error copying'); // todo: remove this line
                              }
                            );
                        }}
                        edge="end"
                      >
                        <ContentCopy />
                      </IconButton>
                    </InputAdornment>
                  }
                  label="Access Token"
                />
              </FormControl>
            </div>
          )}
        </Grid>
        <Grid item>
          <MfButton
            onClick={() => onClose(id, isCurrent)}
            size="small"
            variant="outlined"
            color="secondary"
          >
            Завершить
          </MfButton>
        </Grid>
      </Grid>
    </div>
  );
};

export default SessionItem;
